export default {
  title: 'MAXHUB 設備啟動',
  instruction: '請準確填寫用戶及經銷商信息，此信息將直接影響機器保修及後續延保等商機提供。',
  dealername: '銷售經銷商',
  dealerplaceholder: '經銷商名稱(必填)',
  companyname: '公司名稱',
  companyplaceholder: '公司名稱(必填)',
  tele: '聯繫電話',
  teleplaceholder: '客戶手機或固話(必填)',
  district: '選擇地區',
  distplaceholder: '地區資訊(必選)',
  address: '詳細地址',
  addrplaceholder: '街道門牌資訊(必填)',
  activebtn: '獲取啟動碼',
  confirmbtn: '確認',
  cancelbtn: '取消',
  dialogmessage: '您輸入的聯繫電話格式有誤，請重新輸入',
  dialogbtn: '確認',
  errortitle: '無法打開',
  errorinfo1: '1.嘗試網絡檢查',
  errorinfo2: '2.電話客服專線：400-168-9545',
  nosn: '該設備無SN碼，無法激活',
  activepagetitle: '設備啟動碼',
  activepagehint: '請在設備上輸入啟動碼完成設備啟動',
  finish: '完成',
  search: '搜索附近位置'
};



// WEBPACK FOOTER //
// ./src/i18n/_zh-HK.js